/**
 * NEXT_PUBLIC_ENABLE_APP_BUILDS decide quando vem definida ("true" liga em qualquer host, inclusive
 * producao; "false" desliga). Sem a flag, so staging e ambientes locais mostram builds e o hub.
 */
function getAppBuildsHostname(): string {
  if (typeof window !== "undefined") {
    return window.location.hostname;
  }
  return "";
}

export function isAppBuildsEnabled(currentHostname?: string): boolean {
  const flag = process.env.NEXT_PUBLIC_ENABLE_APP_BUILDS;
  if (flag === "false") {
    return false;
  }
  if (flag === "true") {
    return true;
  }

  const hostname = currentHostname !== undefined ? currentHostname : getAppBuildsHostname();

  if (hostname) {
    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.endsWith(".local")
    ) {
      return true;
    }
    return hostname === "staging.7days.digital" || hostname.includes("staging");
  }

  return process.env.NODE_ENV !== "production";
}
